import { REALITY_FIELD_NAMES } from "../../../smartsetter-utils/filters-dialog/data"

const CALL_STAT_FIELDS = new Set([
  REALITY_FIELD_NAMES.CONCIERGE_DIAL_COUNT,
  REALITY_FIELD_NAMES.CONCIERGE_LAST_DIALED_AT,
  REALITY_FIELD_NAMES.CONCIERGE_LAST_DISPOSITION,
])

function coerceUserId(value) {
  if (value == null || value === "") {
    return null
  }
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : null
}

/**
 * Normalize call-activity filters for the leads API:
 * - promote legacy `performed_by` on dial filters to a User filter
 * - coerce user ids to numbers
 * - strip UI-only keys
 */
export function normalizeLeadCallActivityFilters(filters) {
  if (!Array.isArray(filters) || filters.length === 0) {
    return []
  }

  let legacyPerformedBy = null
  const normalized = []

  for (const filter of filters) {
    const { _id, _complete, exact, performed_by, ...rest } = filter

    if (
      performed_by != null &&
      performed_by !== "" &&
      CALL_STAT_FIELDS.has(rest.field)
    ) {
      legacyPerformedBy = coerceUserId(performed_by)
    }

    if (
      CALL_STAT_FIELDS.has(rest.field) &&
      !rest.type &&
      performed_by != null &&
      performed_by !== ""
    ) {
      continue
    }

    const cleaned = { ...rest }
    if (
      cleaned.field === "performed_by" ||
      cleaned.field === REALITY_FIELD_NAMES.CALL_PERFORMED_BY
    ) {
      if (Array.isArray(cleaned.value)) {
        // "Called by" is any of / none of several users.
        cleaned.field = REALITY_FIELD_NAMES.CALL_PERFORMED_BY
        cleaned.value = cleaned.value
          .map(coerceUserId)
          .filter((userId) => userId != null)
      } else {
        const userId = coerceUserId(cleaned.value)
        if (userId != null) {
          cleaned.field = REALITY_FIELD_NAMES.CALL_PERFORMED_BY
          cleaned.value = userId
        }
      }
    }

    normalized.push(cleaned)
  }

  const hasUserFilter = normalized.some(
    (filter) => filter.field === REALITY_FIELD_NAMES.CALL_PERFORMED_BY
  )

  if (legacyPerformedBy != null && !hasUserFilter) {
    normalized.push({
      field: REALITY_FIELD_NAMES.CALL_PERFORMED_BY,
      type: "is_one_of",
      value: [legacyPerformedBy],
    })
  }

  return normalized
}
